var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "1000px", persistent: "", scrollable: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", { attrs: { left: "", color: "orange" } }, [
                _vm._v("mdi-clock-edit-outline"),
              ]),
              _vm._v(" Adjust Smart Offer Launch Times "),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticStyle: { "max-height": "70vh" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mb-4",
                  attrs: { type: "info", dense: "", text: "" },
                },
                [
                  _c("strong", [_vm._v(_vm._s(_vm.workingOffers.length))]),
                  _vm._v(" offer(s) selected for adjustment "),
                  _vm.skippedMessage
                    ? _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.skippedMessage)),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "v-card",
                { staticClass: "mb-4", attrs: { outlined: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.adjustMode,
                            callback: function ($$v) {
                              _vm.adjustMode = $$v
                            },
                            expression: "adjustMode",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { value: "smart" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c("strong", [_vm._v("Smart Offset")]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [
                                          _vm._v(
                                            " Maintain relative timing between offers "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c("v-radio", {
                            attrs: { value: "manual" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c("strong", [_vm._v("Manual")]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [
                                          _vm._v(
                                            " Adjust each offer individually "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mt-2",
                          attrs: { type: "info", dense: "", text: "" },
                        },
                        [
                          _c("strong", [_vm._v("Note:")]),
                          _vm._v(
                            " Smart Offset adjusts all offers together maintaining relative timing. Manual mode lets you set each offer's date individually while preserving its internal timing rules. "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.adjustMode === "smart"
                ? _c(
                    "v-card",
                    { staticClass: "mb-4", attrs: { outlined: "" } },
                    [
                      _c("v-card-title", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Smart Offset Settings"),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      label: "New Base Date",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      "prepend-inner-icon": "mdi-calendar-edit",
                                      showUnix: false,
                                    },
                                    model: {
                                      value: _vm.newBaseDate,
                                      callback: function ($$v) {
                                        _vm.newBaseDate = $$v
                                      },
                                      expression: "newBaseDate",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption grey--text mt-1",
                                    },
                                    [
                                      _vm._v(
                                        " Set the new launch date - all offers will shift accordingly "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Reference Date (earliest offer)",
                                      value: _vm.formattedReferenceDate,
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      hint: "This is the earliest launch time among selected offers",
                                      "persistent-hint": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-inner",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "grey" } },
                                                [_vm._v("mdi-calendar-clock")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3876069683
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.offsetDays !== 0
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    type:
                                      _vm.offsetDays > 0
                                        ? "success"
                                        : "warning",
                                    dense: "",
                                    text: "",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "Offset: " +
                                        _vm._s(_vm.offsetDaysFormatted)
                                    ),
                                  ]),
                                  _c("br"),
                                  _vm._v(
                                    " All " +
                                      _vm._s(_vm.workingOffers.length) +
                                      " offer(s) will shift by this amount "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.adjustMode === "manual"
                ? _c(
                    "v-card",
                    { staticClass: "mb-4", attrs: { outlined: "" } },
                    [
                      _c("v-card-title", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Manual Adjustment"),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c("v-data-table", {
                            staticClass: "manual-adjustment-table",
                            attrs: {
                              headers: _vm.manualHeaders,
                              items: _vm.manualAdjustmentData,
                              "items-per-page": -1,
                              "hide-default-footer": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.currentDate",
                                  fn: function ({ item }) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(item.currentDate)),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.newDate",
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "py-1" },
                                        [
                                          _c("DateTimePicker", {
                                            attrs: {
                                              outlined: "",
                                              showUnix: false,
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: item.newLaunchTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "newLaunchTime",
                                                  $$v
                                                )
                                              },
                                              expression: "item.newLaunchTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1109795736
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-card",
                { staticClass: "mb-4", attrs: { outlined: "" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "text-subtitle-1" },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-eye-outline"),
                      ]),
                      _vm._v(" Preview Changes "),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c("v-simple-table", { attrs: { dense: "" } }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Offer Name")]),
                            _c("th", [_vm._v("Current Launch (UTC)")]),
                            _c("th"),
                            _c("th", [_vm._v("New Launch (UTC)")]),
                            _c("th", [_vm._v("Change")]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.previewData, function (item) {
                            return _c("tr", { key: item.uid }, [
                              _c("td", { staticClass: "text-caption" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              _c("td", { staticClass: "text-caption" }, [
                                _vm._v(_vm._s(item.oldDate)),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "grey" } },
                                    [_vm._v("mdi-arrow-right")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                {
                                  staticClass: "text-caption font-weight-bold",
                                },
                                [_vm._v(_vm._s(item.newDate))]
                              ),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        color:
                                          item.diff === "No change"
                                            ? "grey"
                                            : item.diff.startsWith("+")
                                            ? "green"
                                            : "orange",
                                        "text-color": "white",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(item.diff) + " ")]
                                  ),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm.previewData.length === 0
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2",
                              attrs: { type: "warning", dense: "", text: "" },
                            },
                            [
                              _vm._v(
                                " No changes to preview. Please adjust the dates. "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ open }) {
                              return [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { left: "", small: "" } },
                                          [_vm._v("mdi-cog-outline")]
                                        ),
                                        _vm._v(" Advanced Settings "),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "text--secondary",
                                        attrs: { cols: "8" },
                                      },
                                      [
                                        _c(
                                          "v-fade-transition",
                                          { attrs: { "leave-absolute": "" } },
                                          [
                                            !open
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Optional: Set resetTime, cooldown, quantity for all offers "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Reset Time",
                                      type: "number",
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      hint: "e.g., 86400 (24 hours)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.advancedSettings.resetTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advancedSettings,
                                          "resetTime",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "advancedSettings.resetTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Cooldown",
                                      type: "number",
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      hint: "e.g., 3600 (1 hour)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.advancedSettings.cooldown,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advancedSettings,
                                          "cooldown",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "advancedSettings.cooldown",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Quantity",
                                      type: "number",
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      hint: "e.g., 0 (unlimited)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.advancedSettings.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.advancedSettings,
                                          "quantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "advancedSettings.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-alert",
                            { attrs: { type: "info", dense: "", text: "" } },
                            [
                              _vm._v(
                                " These settings will be applied to all selected offers if values are provided. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v(" Cancel "),
              ]),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "orange",
                    disabled: !_vm.canApply,
                    loading: _vm.loading,
                  },
                  on: { click: _vm.applyChanges },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-check"),
                  ]),
                  _vm._v(
                    " Apply Changes (" +
                      _vm._s(_vm.workingOffers.length) +
                      " offers) "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }